<template>
	<div class="socials">
		<a
			v-for="medium in socials"
			:key="medium.ID"
			:class="medium.platform"
			:href="medium.url"
			:aria-label="medium.platform"
			target="_blank"
		>
			<font-awesome-icon
				v-if="!['tripadvisor', 'zoover'].includes(medium.platform)"
				:icon="`fa-brands fa-${medium.platform}`"
				size="1x"
			/>
		</a>
	</div>
</template>

<script setup>
defineProps({
	socials: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.socials .tripadvisor {
	background: url('~/assets/images/tripadvisor-white.svg') no-repeat center center;
	background-size: 22px;
	width: 40px;
	height: 40px;
	line-height: 40px;
}

.socials .tripadvisor:hover {
	background: url('~/assets/images/tripadvisor-hover.svg') no-repeat center center;
	background-size: 22px;
}

.socials {
	display: flex;
	align-items: center;
	place-content: center flex-start;

	a {
		color: var(--primary-background-color);
		display: flex;
		align-items: center;
		place-content: center center;
		line-height: 40px;
		text-align: center;
		font-size: 22px;
		margin: 5px 15px 5px 0;
		text-decoration: none;

		&:hover {
			color: #fff;
		}
	}
}
</style>
